import { types } from 'mobx-state-tree';

import LicenceSuspensionTypeValues from '../definitions/LicenceSuspensionTypeValues';


const LicenceSuspension = types
    .model('LicenceSuspension', {
        id: types.identifier,
        type: types.enumeration(
            Object.values(LicenceSuspensionTypeValues),
        ),
        date: types.string,
        hasSuspensionEnded: types.boolean,
        nextInsuranceDate: types.maybeNull(types.string),
    });

export default LicenceSuspension;
